import { contentApi, loyaltyApi } from '@/infrastructure/Configuration'
import { zimbaService } from '@/infrastructure/Factory'

const defaultGetConfig = {
  headers: { 'Content-Type': 'application/json' },
  data: {}
}

export default class NlpService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getProfileListValues (memberType) {
    try {
      const { data: countriesData } = await this.httpClient.get(`${loyaltyApi}/sign-up/countries?memberType=${memberType}`, defaultGetConfig)
      const { data: languagesData } = await this.httpClient.get(`${contentApi}/loyalty-languages`)
      const { data: catalogData } = await this.httpClient.get(`${loyaltyApi}/catalog/profile`, defaultGetConfig)
      const destinations = await zimbaService.getDestinations()
      const cities = this.reduceDestinationsToCities(destinations)

      const mapCatalogFrom = (catalogKey) => {
        try {
          return catalogData[catalogKey].map(x => ({
            code: x.id,
            name: x.text,
            position: x.position
          }))
        } catch (e) { return [] }
      }
      return {
        countries: countriesData.countries,
        nationalities: this.mapNationalitiesToCatalog(countriesData.countries),
        languages: languagesData.languages,
        cities: this.mapCitiesToCatalog(cities),
        title: [
          { code: 'Mr', name: 'Mr.' },
          { code: 'Mrs', name: 'Mrs.' },
          { code: 'Other', name: 'Other' }
        ],
        gender: catalogData.gender.map(x => ({
          code: x.id,
          name: x.text
        })),
        children: catalogData.children.map(x => ({
          code: x.id,
          name: x.text
        })),
        crowd: mapCatalogFrom('crowd'),
        reasonForTravel: mapCatalogFrom('reasonForTravel'),
        documentType: mapCatalogFrom('documentType'),
        numberOfReservationsPerYear: mapCatalogFrom('numberOfReservationsPerYear'),
        reasonForBooking: mapCatalogFrom('reasonForBooking'),
        typeOfBookingDestination: mapCatalogFrom('typeOfBookingDestination'),
        typeOfHotelsBooked: mapCatalogFrom('typeOfHotelsBooked'),
        industries: mapCatalogFrom('industries'),
        numberOfEventsPerYear: mapCatalogFrom('numberOfEventsPerYear'),
        mostInterestedBrand: mapCatalogFrom('mostInterestedBrand'),
        sizeOfUsualEvents: mapCatalogFrom('sizeOfUsualEvents'),
        meRole: mapCatalogFrom('meRole')
      }
    } catch (e) {
      return {
        countries: [],
        nationalities: [],
        languages: [],
        cities: [],
        title: [],
        gender: [],
        children: [],
        crowd: [],
        reasonForTravel: [],
        documentType: [],
        numberOfReservationsPerYear: [],
        reasonForBooking: [],
        typeOfBookingDestination: [],
        typeOfHotelsBooked: [],
        numberOfEventsPerYear: [],
        mostInterestedBrand: [],
        sizeOfUsualEvents: [],
        industries: [],
        meRole: ''
      }
    }
  }

  reduceDestinationsToCities (destinations) {
    const allRegions = destinations
      .map(continent => continent.countriesOrStates)
      .reduce((acc, curr) => [...acc, ...curr], [])
    return allRegions
      .map(region => region.cities)
      .reduce((acc, curr) => [...acc, ...curr], [])
  }

  mapCitiesToCatalog = (cities) => {
    try {
      return cities.map(x => ({
        code: x.code,
        name: x.name,
        position: 0
      }))
    } catch (e) { return [] }
  }

  mapNationalitiesToCatalog = (countries) => {
    try {
      return countries.map(country => {
        if (country.additionalProperties && country.additionalProperties.nationality) {
          const citiesWithSameNationality = countries.filter(city => {
            return city.additionalProperties && city.additionalProperties.nationality === country.additionalProperties.nationality
          })
          if (citiesWithSameNationality.length > 1) {
            return {
              name: `${country.additionalProperties.nationality} (${country.name})`,
              code: country.code,
              position: 0
            }
          } else {
            return {
              name: country.name,
              code: country.code,
              position: 0
            }
          }
        } else {
          return {
            name: country.name,
            code: country.code,
            position: 0
          }
        }
      }).sort((a, b) => a.name.localeCompare(b.name))
    } catch (error) {
      console.error('Error:', error)
      return []
    }
  }
}
